import React, { Component } from "react"
import PropTypes from "prop-types"
import { Row, Col, Card, CardBody } from "reactstrap"
import { Link, withRouter  } from "react-router-dom"
import gridView from "../../../assets/img/grid-view.png"
import engagementView from "../../../assets/img/engagement-view.png"


class ClientPageMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  isActive(path) {
    return this.props.location.pathname === path ? "active" : ""
  }
  render() {
    const { isResponsive } = this.props;
    return (
        <React.Fragment>           
        <Row className="">
          <Col sm="12">
          {isResponsive ? (
            <>
            <h6>Select Menu</h6>
            <select
                className="form-select w-100"
                value={
                  this.isActive("/clients") ? "/clients" :
                  this.isActive("/rental-clients") ? "/rental-clients" :
                  this.isActive("/in-clients") ? "/in-clients" :
                   this.isActive("/upcoming-closing") ? "/upcoming-closing" :
                  ""
                }
                onChange={(e) => this.props.history.push(e.target.value)}
              >
                <option value="/clients">Active clients</option>
                <option value="/rental-clients">Rental</option>
                <option value="/in-clients">In-active clients</option>
                 <option value="/upcoming-closing">Upcoming closing</option>
              </select>
            </>
          ):(
             <div className="">
              <div className="btn-group rl-group-btn" role="group">
                <Link to="/clients">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/clients")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                        Active clients
                    <img src={gridView} style={{height:16}}  />
                  
                    </span>
                  </button>
                </Link>
                <Link to="/rental-clients">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/rental-clients")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                  
                   
                    Rental
                      <img src={engagementView} style={{height:16}}  />
                    </span>
                  </button>
                </Link>
                  <Link to="/in-clients">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/in-clients")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                        In-active clients
                    <img src={gridView} style={{height:16}}  />
                  
                    </span>
                  </button>
                </Link>
                 <Link to="/upcoming-closing">
                  <button
                    type="button"
                    className={`btn btn-outline-secondary w-xs bt-filter-v2 ${this.isActive("/upcoming-closing")}`}
                  >
                     <span className="d-flex align-items-center gap-2">
                        Upcoming closing
                    <img src={gridView} style={{height:16}}  />
                  
                    </span>
                  </button>
                </Link>
              </div>
            </div>  
          )}
              
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
ClientPageMenu.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired
    }).isRequired,
    isResponsive:PropTypes.object,
    history:PropTypes.object
  }
export default withRouter(ClientPageMenu)
